import { NgModule } from '@angular/core';
import { AppStep1Component } from './step1.component';
import { LocalService } from '../local.services';
import { AppStep1ThankComponent } from './thank/step1-thank.component';
import { SharedModule } from '@core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AgmCoreModule } from '@agm/core';
import { Step1Guard } from '../guards/step1.guard';
import { AppPopOverStepsModule } from '../popover/popover.module';
import { AppTooltipModule } from '@core/components/tooltip/tooltip.module';
import { AppProgresStepsModule } from '../probress-steps/progress-steps.module';
import { environment } from 'environments/environment';
const routes = [
    {
        path: '',
        component: AppStep1Component,
        resolve: {
            local: LocalService
        }
    },
    {
        path: 'gracias',
        component: AppStep1ThankComponent,

    },
];

@NgModule({
    declarations: [
        AppStep1Component,
        AppStep1ThankComponent,
    ],
    imports: [
        SharedModule,
        AppPopOverStepsModule,
        RouterModule.forChild(routes),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDVQxWZKo4_Fhf77XPxiuk_JBS2JthC5jE',
            libraries: ['places']
        }),
        AppTooltipModule,
        AppProgresStepsModule,
    ],
    providers: [
        Step1Guard,
    ]
})

export class Step1Module {

}
